import React from 'react';
import { DateFormat } from '../../../_lib/components/DateFormat';
import { DefinitionList } from '../../../_lib/components/DefinitionList';
import { ContentLink, ContentLinkModifier } from '../../../_lib/components/ContentLink';
import { ContentHeadline } from '../../../_lib/components/ContentHeadline';
import { PagePackState } from '../../../types/api/PagePackState';
import ILink from '../../../types/ILink';
import { useSonTranslation } from '../../../translation/useSonTranslation';

export type BlogPostSiblingItem = {
  link: ILink;
  author: ILink;
  creationDate: string;
  packState: string;
};

export function BlogPostSiblingItem({ link, author, creationDate, packState }: BlogPostSiblingItem) {
  const { t } = useSonTranslation('Blogs');
  let dlCreatedAt = {};
  let dlCreatedBy = {};

  if (author) {
    dlCreatedBy = {
      term: t('siblings.createdOf'),
      class: 'invisible',
      definitionDescriptions: [
        {
          description: (
            <>
              <ContentLink to={author.url} modifier={ContentLinkModifier.REGULAR}>
                {author.name}
              </ContentLink>
              {creationDate && <span className="font-regular-15-19">,&nbsp;</span>}
            </>
          ),
        },
      ],
    };
  }

  if (creationDate) {
    dlCreatedAt = {
      term: t('siblings.createdOn'),
      class: 'invisible',
      definitionDescriptions: [
        {
          description: <DateFormat date={creationDate} />,
          class: 'font-regular-15-19',
        },
      ],
    };
  }
  return (
    <article>
      <ContentHeadline
        url={link.url}
        title={link.name}
        stateIndicatorStatus={packState === PagePackState.ONLY_DRAFT_VERSION ? 'red' : undefined}
      />
      <DefinitionList definitionTerms={[dlCreatedBy, dlCreatedAt]} className="blog-post-siblings" />
    </article>
  );
}
